import {Component, forwardRef, HostBinding, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonInputBaseComponent} from 'app/core/ion-components/ionInput';
import {HelperService} from '../../../services/helper.service';
import {InputState} from 'app/entities/enums';
import {InputChangeEventDetail} from '@ionic/angular';

@Component({
  selector: 'app-input',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})

/**
 * Usage:
 * ```
 * ```
 *
 * Configurable params:
 *  - type
 */
export class InputComponent extends IonInputBaseComponent implements OnInit {

  @Input() labelText?: string = null;
  @Input() size: 'medium' | 'large' = 'medium';
  @Input() state: InputState;
  @Input() showErrorElement = true;
  @Input() errorText: string;
  @Input() errorTextPosition: 'left' | 'right' | 'center' = 'left';
  @Input() inputIcon: 'search';
  @Input() inputForCode = false;
  @Input() requiredLabel = false;
  @Input() onlyNumbers = false;
  @Input() numberType: 'number' | null = null;
  @Input() thousandSeparator = false;
  @Input() addClass = '';

  @HostBinding('class')
  get classes() {
    return {
      [`input-state-${this.state}`]: this.state,
      [`input-size-${this.size}`]: this.size,
      [`input-icon-${this.inputIcon}`]: this.inputIcon,
      'input-icon-show': this.inputIcon,
      'input-for-code': this.inputForCode,
      'input-clear': this.clearInput,
      'input-disabled': this.disabled
    };
  }

  ngOnInit() {
    // @todo make something smarter
    setTimeout(() => {

      if (this.value && this.mask && this.value.startsWith('8') && this.value.length === 11) {
        const phone = HelperService.getFormattedPhone(this.value);

        this.value = phone ? phone : this.value;
      }

    }, 10);
  }

  onChange(event: CustomEvent<InputChangeEventDetail> | any) {
    if (this.thousandSeparator) {
      this.value = HelperService.formatNumber(event.detail.value);
    }

    // this.ionChange.emit(event);
  }
}
